import {
  CloudChatBotDetailPage,
  CloudChatBotListPage,
  CloudChatBotReportPage,
  CloudLanguageDetailPage,
  CloudLanguageListPage,
  CloudPartnerDetailPage,
  CloudPartnerListPage,
  CloudPermissionDetailPage,
  CloudRoleTemplateDetailPage,
  CloudRoleTemplateListPage,
} from "@Elements";
import { DashboardBaseRoute } from "./Dashboard.route";
import { createRoute, redirect } from "@tanstack/react-router";

export const CloudBaseRoute = createRoute({
  getParentRoute: () => DashboardBaseRoute,
  path: "/cloud",
  staticData: {
    TITLE: "Bulut Yönetimi",
    IS_BASE_ROUTE: true,
  },
  beforeLoad: (route) => {
    if (route.location.pathname === CloudBaseRoute.fullPath)
      throw redirect({
        to: CloudRoleTemplateListRoute.fullPath,
      });
  },
});

export const CloudRoleTemplateBaseRoute = createRoute({
  getParentRoute: () => CloudBaseRoute,
  path: "/role-template",
  beforeLoad: (route) => {
    if (route.location.pathname === CloudRoleTemplateBaseRoute.fullPath)
      throw redirect({
        to: CloudRoleTemplateListRoute.fullPath,
      });
  },
});

export const CloudRoleTemplateListRoute = createRoute({
  getParentRoute: () => CloudRoleTemplateBaseRoute,
  path: "/list",
  component: CloudRoleTemplateListPage,
  staticData: {
    TITLE: "Rol Tanımları Listesi",
  },
});

export const CloudRoleTemplateAddRoute = createRoute({
  getParentRoute: () => CloudRoleTemplateBaseRoute,
  path: "/add",
  component: CloudRoleTemplateDetailPage,
  staticData: {
    TITLE: "Rol Tanımı Oluştur",
    PARENT_ROUTE: CloudRoleTemplateListRoute,
  },
});

export const CloudRoleTemplateEditRoute = createRoute({
  getParentRoute: () => CloudRoleTemplateBaseRoute,
  path: "/edit/$id",
  component: CloudRoleTemplateDetailPage,
  staticData: {
    TITLE: "Rol Tanımı Düzenle",
    PARENT_ROUTE: CloudRoleTemplateListRoute,
  },
});

export const CloudPermissionBaseRoute = createRoute({
  getParentRoute: () => CloudBaseRoute,
  path: "/permission",
  beforeLoad: (route) => {
    if (route.location.pathname === CloudPermissionBaseRoute.fullPath)
      throw redirect({
        to: CloudPermissionBaseRoute.fullPath,
      });
  },
});

export const CloudPermissionDetailRoute = createRoute({
  getParentRoute: () => CloudPermissionBaseRoute,
  path: "/detail",
  component: CloudPermissionDetailPage,
  staticData: {
    TITLE: "Yetki Yönetimi",
  },
});

export const CloudLanguageBaseRoute = createRoute({
  getParentRoute: () => CloudBaseRoute,
  path: "/language",
  beforeLoad: (route) => {
    if (route.location.pathname === CloudLanguageBaseRoute.fullPath)
      throw redirect({
        to: CloudLanguageListRoute.fullPath,
      });
  },
});

export const CloudLanguageListRoute = createRoute({
  getParentRoute: () => CloudLanguageBaseRoute,
  path: "/list",
  component: CloudLanguageListPage,
  staticData: {
    TITLE: "Diller Listesi",
  },
});

export const CloudLanguageAddRoute = createRoute({
  getParentRoute: () => CloudLanguageBaseRoute,
  path: "/add",
  component: CloudLanguageDetailPage,
  staticData: {
    TITLE: "Dil Oluştur",
    PARENT_ROUTE: CloudLanguageListRoute,
  },
});

export const CloudLanguageEditRoute = createRoute({
  getParentRoute: () => CloudLanguageBaseRoute,
  path: "/edit/$code",
  component: CloudLanguageDetailPage,
  staticData: {
    TITLE: "Dil Düzenle",
    PARENT_ROUTE: CloudLanguageListRoute,
  },
});

export const CloudChatBotBaseRoute = createRoute({
  getParentRoute: () => CloudBaseRoute,
  path: "/chatbot",
  beforeLoad: (route) => {
    if (route.location.pathname === CloudChatBotBaseRoute.fullPath)
      throw redirect({
        to: CloudChatBotListRoute.fullPath,
      });
  },
});

export const CloudChatBotListRoute = createRoute({
  getParentRoute: () => CloudChatBotBaseRoute,
  path: "/list",
  component: CloudChatBotListPage,
  staticData: {
    TITLE: "Chat Bot",
  },
});

export const CloudChatBotAddRoute = createRoute({
  getParentRoute: () => CloudChatBotBaseRoute,
  path: "/add",
  component: CloudChatBotDetailPage,
  staticData: {
    TITLE: "Chat Bot Planı Oluştur",
    PARENT_ROUTE: CloudChatBotListRoute,
  },
});

export const CloudChatBotEditRoute = createRoute({
  getParentRoute: () => CloudChatBotBaseRoute,
  path: "/edit/$id",
  component: CloudChatBotDetailPage,
  staticData: {
    TITLE: "Chat Bot Planı Düzenle",
    PARENT_ROUTE: CloudChatBotListRoute,
  },
});

export const CloudChatBotReportRoute = createRoute({
  getParentRoute: () => CloudChatBotBaseRoute,
  path: "/report",
  component: CloudChatBotReportPage,
  staticData: {
    TITLE: "Chat Bot Abonelik Raporu",
    PARENT_ROUTE: CloudChatBotListRoute,
  },
});

export const CloudPartnerBaseRoute = createRoute({
  getParentRoute: () => CloudBaseRoute,
  path: "/partner",
  beforeLoad: (route) => {
    if (route.location.pathname === CloudPartnerBaseRoute.fullPath)
      throw redirect({
        to: CloudPartnerListRoute.fullPath,
      });
  },
});

export const CloudPartnerListRoute = createRoute({
  getParentRoute: () => CloudPartnerBaseRoute,
  path: "/list",
  component: CloudPartnerListPage,
  staticData: {
    TITLE: "İş Ortakları Listesi",
  },
});

export const CloudPartnerAddRoute = createRoute({
  getParentRoute: () => CloudPartnerBaseRoute,
  path: "/add",
  component: CloudPartnerDetailPage,
  staticData: {
    TITLE: "İş Ortağı Oluştur",
    PARENT_ROUTE: CloudPartnerListRoute,
  },
});

export const CloudPartnerEditRoute = createRoute({
  getParentRoute: () => CloudPartnerBaseRoute,
  path: "/edit/$id",
  component: CloudPartnerDetailPage,
  staticData: {
    TITLE: "İş Ortağı Düzenle",
    PARENT_ROUTE: CloudPartnerListRoute,
  },
});

export const CloudRouteTree = CloudBaseRoute.addChildren([
  CloudRoleTemplateBaseRoute.addChildren([
    CloudRoleTemplateListRoute,
    CloudRoleTemplateAddRoute,
    CloudRoleTemplateEditRoute,
  ]),
  CloudPermissionBaseRoute.addChildren([CloudPermissionDetailRoute]),
  CloudLanguageBaseRoute.addChildren([
    CloudLanguageListRoute,
    CloudLanguageAddRoute,
    CloudLanguageEditRoute,
  ]),
  CloudChatBotBaseRoute.addChildren([
    CloudChatBotListRoute,
    CloudChatBotAddRoute,
    CloudChatBotEditRoute,
    CloudChatBotReportRoute,
  ]),
  CloudPartnerBaseRoute.addChildren([
    CloudPartnerListRoute,
    CloudPartnerAddRoute,
    CloudPartnerEditRoute,
  ]),
]);
